import { render, staticRenderFns } from "./NieuwsmakerSlide.vue?vue&type=template&id=e07b622c"
import script from "./NieuwsmakerSlide.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports